<template>
  <HomeConnect />
</template>

<script>
  import HomeConnect from "@/components/HomeConnect.vue";
  export default {
    name: "ProductListPage",
    components: {
      HomeConnect,
    },
  };
</script>
